class AEGlobalShell {
  constructor() {
    this.header = document.querySelector('[data-ae-header]');
    this.mobileMenu = document.querySelector('[data-ae-mobile-menu]');
    this.mobileOpeners = document.querySelectorAll('[data-ae-mobile-open]');
    this.mobileClosers = document.querySelectorAll('[data-ae-mobile-close]');

    this.initStickyHeader();
    this.initMobileMenu();
  }

  initStickyHeader() {
    if (!this.header) return;

    const setSticky = () => {
      this.header.classList.toggle('is-sticky', window.scrollY > 40);
    };

    setSticky();
    window.addEventListener('scroll', setSticky, { passive: true });
  }

  initMobileMenu() {
    if (!this.mobileMenu) return;

    this.mobileOpeners.forEach((button) => {
      button.addEventListener('click', () => this.openMobileMenu(button));
    });

    this.mobileClosers.forEach((button) => {
      button.addEventListener('click', () => this.closeMobileMenu());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.mobileMenu.classList.contains('is-open')) {
        this.closeMobileMenu();
      }
    });
  }

  openMobileMenu(button) {
    this.mobileMenu.classList.add('is-open');
    this.mobileMenu.setAttribute('aria-hidden', 'false');
    button?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('ae-mobile-open');
  }

  closeMobileMenu() {
    this.mobileMenu.classList.remove('is-open');
    this.mobileMenu.setAttribute('aria-hidden', 'true');
    this.mobileOpeners.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    document.documentElement.classList.remove('ae-mobile-open');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.aeGlobalShell = new AEGlobalShell();
});
